import classNames from 'classnames';
import styles from './icons.module.scss';

export interface IconProps {
  type: "error" | "menuHome" | "menuProcess" | "menuHelp" | "menuProfile" | "menuSettings" |
  "favorite" | "favoriteActive" | "location" | "hours" | "workMode" | "goBack" | "edit" |
  "info" | "alertPage" | "successCheck" | "deleted";

  active?: boolean;
}

export const Icon = ({ type, active }: IconProps) => (
  <span className={classNames(styles.icon, styles[type], { [styles.active]: active })} />
)   